import React from "react";
import { FaFilePdf } from "react-icons/fa";
import { HiOutlineDownload } from "react-icons/hi";

// Dummy data
const documentsData = {
  Today: [
    { title: "Don Quixote", size: "24 MB", type: "PDF Document" },
    { title: "PSD Design Sample", size: "15 MB", type: "PSD Document" },
  ],
  Yesterday: [
    { title: "Don Quixote", size: "24 MB", type: "PDF Document" },
    { title: "Report PSD", size: "12 MB", type: "PSD Document" },
  ],
  "Last Month": [
    { title: "Don Quixote", size: "24 MB", type: "PDF Document" },
    { title: "Old Archive PSD", size: "30 MB", type: "PSD Document" },
  ],
};

// Reusable Card Component
const DocumentCard = ({ title, size, type, withDownload = true }) => {
  const handleDownload = () => {
    // Add actual download logic here (e.g. using FileSaver or blob download)
    alert(`Downloading "${title}"`);
  };

  const isPDF = type.toLowerCase().includes("pdf");

  return (
    <div className="flex items-start justify-between gap-3 border border-[#EBEBEB] rounded-xl p-2 w-full max-w-md">
      <div className="flex items-start gap-3">
        <div className={`min-w-[32px] min-h-[42px] max-w-[32px] max-h-[42px] flex items-center justify-center ${isPDF ? "bg-red-100" : "bg-blue-100"} rounded-lg`}>
          <FaFilePdf className={`${isPDF ? "text-red-500" : "text-blue-500"} text-lg`} />
        </div>
        <div>
          <h3 className="font-semibold text-sm w-2/3 truncate">{title}</h3>
          <p className="text-xs text-gray-500 mt-1">{size} • {type}</p>
        </div>
      </div>
      {withDownload && (
        <div>
       <button
  onClick={handleDownload}
  className="flex items-center justify-center shadow-md rounded-full border-none h-10 w-10 bg-white"
>
  <HiOutlineDownload className="text-[var(--primary-color)] text-2xl" />
</button>

        </div>
      )}
    </div>
  );
};

export default function Documents() {
  return (
    <section className="">
      {Object.entries(documentsData).map(([section, docs], idx) => (
        <div className={idx !== 0 ? "my-4" : ""} key={section}>
          <label className="text-sm font-semibold">{section}</label>
          <div className="flex flex-col gap-3 mt-2">
            {docs.map((doc, index) => (
              <DocumentCard
                key={index}
                title={doc.title}
                size={doc.size}
                type={doc.type}
              />
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}
